module.exports = __webpack_public_path__ + "img/ntk_timeline_end.14389fd3.svg";